/* eslint-disable no-case-declarations */
import actionTypes from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';
import initialState from 'redux/initialState';

export default function reducer(
  holdingClasses = initialState.holdingClasses,
  action
) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return initialState.holdingClasses;

    case actionTypes.CREATE_HOLDING_CLASS:
      return [...holdingClasses, action.holdingClass];

    case actionTypes.GET_HOLDING_CLASSES: {
      if (action?.data[0]?.createdAt) {
        return action.data.sort(
          (a, b) =>
            new Date(a?.createdAt)?.getTime() -
            new Date(b?.createdAt)?.getTime()
        );
      }
      return action.data;
    }

    case actionTypes.UPDATE_HOLDING_CLASS:
      return [
        ...holdingClasses.filter(
          (holdingClass) => holdingClass['_id'] !== action.holdingClass['_id']
        ),
        action.holdingClass,
      ];

    default:
      return holdingClasses;
  }
}
